export default {
  mounted() {
    this.previousFocus = document.activeElement
    this.restores = []
    let child = this.el.closest("#execution-modal")
    while (child?.parentElement && child.parentElement !== document.documentElement) {
      for (const sibling of child.parentElement.children) {
        if (sibling !== child && !["SCRIPT", "STYLE", "LINK"].includes(sibling.tagName)) {
          this.restores.push([sibling, sibling.inert]); sibling.inert = true
        }
      }
      child = child.parentElement
    }
    this.keyHandler = event => {
      if (event.target.getAttribute("role") !== "tab" || !["ArrowLeft", "ArrowRight", "Home", "End"].includes(event.key)) return
      event.preventDefault()
      event.stopPropagation()
      const tabs = [...this.el.querySelectorAll('[role="tab"]')]
      const current = tabs.indexOf(event.target)
      const index = event.key === "Home" ? 0 : event.key === "End" ? tabs.length - 1 : (current + (event.key === "ArrowRight" ? 1 : -1) + tabs.length) % tabs.length
      tabs[index].focus(); tabs[index].click()
    }
    this.el.addEventListener("keydown", this.keyHandler)
    this.el.querySelector("#execution-close")?.focus()
  },
  destroyed() {
    this.el.removeEventListener("keydown", this.keyHandler)
    for (const [element, wasInert] of this.restores) if (element.isConnected) element.inert = wasInert
    if (this.previousFocus?.isConnected) this.previousFocus.focus()
  }
}
